import React from 'react';
import { TableBody } from '@mui/material';
import { ArcTableBodyProps } from './types';

const ArcTableBody: React.FC<ArcTableBodyProps> = (props) => {
  return <TableBody {...props} />;
};

export default ArcTableBody;